import type { BusinessUnit } from "@/hooks/types";

/**
 * Whether a business unit is organised into houses (Jira NAV-218, ADR 0025).
 *
 * **Off unless the unit says otherwise.** Most units are not organised into
 * houses, and for them a Houses page would be an empty table inviting an
 * admin to set up something their unit does not have. The switch is a setting
 * on the unit, written by its tenancy configuration and by nothing in the app,
 * so turning it on for another unit is a configuration change.
 *
 * A function over the unit rather than `bu?.usesHouses === true` at each call
 * site, for the reason `showsRecommendedTools` gives: the rail that offers the
 * page and the page that refuses to open must agree about a unit that never
 * answered. Unlike that one, the default here is *off*, so a unit document
 * still in flight reads as not using houses — the entry appears once the unit
 * has arrived rather than blinking out.
 */
export function unitUsesHouses(
  businessUnit: Pick<BusinessUnit, "usesHouses"> | null | undefined,
): boolean {
  return businessUnit?.usesHouses === true;
}
